import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {

  setup() {

    let banner = document.querySelector('.banner');
    if(banner) {
      const first = banner.querySelector(".first");
      const second = banner.querySelector(".second");

      const bannertl = gsap.timeline();

      bannertl
      .set(first, {yPercent: 25})
      .set(second, {yPercent: 25})
      .to(first, {
        yPercent: 0,
        autoAlpha: 1,
        duration: 1,
        delay: 0.3,
        ease: "power1.out"
      })
      .to(second, {
        yPercent: 0,
        autoAlpha: 1,
        duration: 1,
        ease: "power1.out"
      }, "-=0.5")

    }

    const timelineSections = gsap.utils.toArray('.timeline-entry');

    timelineSections.forEach(section => {
      gsap.set(section, {
        y: 30,
      })
      gsap.to(section, { 
        autoAlpha: 1,
        y: 0,
        duration: 1,
        scrollTrigger: {
          trigger: section,
          start: "top 60%",
          end: "bottom 40%",
        }
      })
    });

  },
  destroy() {

  },
}